export const DRAGONBONES_PATH: string = 'resource/dragonbones';
